import { render, staticRenderFns } from "./ScreenAdapter.vue?vue&type=template&id=0424c309"
import script from "./ScreenAdapter.vue?vue&type=script&lang=js"
export * from "./ScreenAdapter.vue?vue&type=script&lang=js"
import style0 from "./ScreenAdapter.vue?vue&type=style&index=0&id=0424c309&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports